import moment from "moment"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { IoFilterOutline } from "react-icons/io5"
import { useScope } from "../SelectProjectCompanyContainer"
import { useDWOptions } from "../../core/utils/hooks/useDwOptions"
import { setData } from "../../core/redux/app/Actions"
import Send from "../../core/communication"
import { AssistanceListScreen } from "../../screen/AssistanceListScreen"
import { FilterModal } from "../../screen/DashboardScreen"

export const loadData = async (values, scope) => {
  let newProjects = dataFilter?.projects || [];
  
  if(values?.projects && values?.projects.length) newProjects = values?.projects || [];

  if(!Array.isArray(newProjects) || !newProjects.length) newProjects = [{value: scope?.id}];

  newProjects = newProjects
    .filter(item => item?.value)
    .map(project => project.label !== 'Ambev' ? `'${project?.value}'` : project?.value).toString();

  let extraProps = "order=DESC%20createdAt";

  if (values?.farmers && values.farmers.length) {
    extraProps += `&value=${farmer.label}&searchType=Farmer`
  }

  if (values?.technician && values?.technician?.label) {
    extraProps += `value=${technician?.label}&searchType=Tech`
  }

  if(dataFilter?.year) {
    extraProps += `&year=${dataFilter.year}`
  }

  if(values?.year) {
    extraProps += `&year=${values.year}`
  }

  if (values?.forms && values?.forms.length) {
    const formattedForms = values.forms.filter(item => item && item.value).map(item => `'${forms.value}'`);
    extraProps += `&forms=${formattedForms}`
  }

  const getDetails = await Send.get(`/assistance/user/${currentUser.id}`, `${extraProps}&projects=${newProjects}`);

  return getDetails
}

export const loadTec = async (currentUser, scope) => {
  const getDetails = Send.get(`/assistance/user/${currentUser.id}`, `&projects='${scope?.id}'`)
  let data = []

  await Promise.all([getDetails]).then(([getDetails]) => {
    if(getDetails && getDetails.data) {
      data = Array.isArray(getDetails?.data) && getDetails?.data .map((i) => i.user).filter(row => row?.id);
    }
  })

  return data
}

const SubHeaderFilterTable = ({
  setIsOpen,
  isOpen,
  onChange,
  loading,
  dw,
  values,
  control,
  onSearch,
}) => {
  return (
    <>
      <div class="div-btn-filter">
        <div class="icon-container" onClick={() => setIsOpen(true)}>
          <IoFilterOutline className="icon-filter" />
          <text class="text-filter">Filtrar</text>
        </div>
      </div>
      <FilterModal
        {...{
          useProjects: true,
          modalIsOpen: isOpen,
          setModalIsOpen: setIsOpen,
          onChange,
          loading,
          dw,
          values,
          journey: false,
          useQuestions: false,
          control,
          onSearch,
          type: 'year',
          period: true
        }}
      />
    </>
  )
}

const AssistanceListContainer = () => {
  const defaultData = useSelector(state => state.app.assistanceList);
  const { scope } = useScope()
  const dataFilter = useSelector((state) => state.app.filter);
  const currentUser = useSelector((state) => state.app.user.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [dw, reload] = useDWOptions()
  const [getDetails, setgetDetails] = useState(defaultData?.data || [])
  const [transform, setDataTransform] = useState([])
  const [values, setValues] = useState([])
  const [temp, setTempData] = useState()
  const [isOpen, setIsOpen] = useState(false)

  const { control, setValue } = useForm({
    mode: "onBlur",
  })


  useEffect(() => {
    if (scope?.id) {
      dispatch(setData({ assistanceList: loadData(values, scope).data || [] }));
      setgetDetails(loadData(values, scope).data || []);
      setTempData(loadTec(currentUser, scope))
    }
  }, [scope?.id])

  useEffect(() => {
    setDataTransform([transformDataToTable()])
  }, [getDetails])

  const onFilter = (key, contentKey, data) => {
    data = getDetails.filter(item => item && item?.id === data?.ID)[0];
    dispatch(
      setData({
        assistanceUsers: data?.assistUser || [],
        assistanceTechnician: data?.user || {},
        assistanceDate: moment(data?.createdAt).format('DD/MM/YYYY')
      }),
    )

    navigate(`/assistance/${data.id}/details`)
  }

  const onChange = (field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const onSearch = () => {
    loadData();
    setIsOpen(false)
  }

  useEffect(() => {
    if (isOpen) {
      setValue("technician", "")
      setValue("farmers", "")
      setValue("projects", "")
      setValue("forms", "")
      setTempData([])
    }
  }, [isOpen])

  const transformDataToTable = () => {
    return {
      codes: [
        { title: "id", code: "ID" },
        { title: "Projeto", code: "Projeto" },
        { title: "Técnico", code: "Tecnico" },
        { title: "Formulário", code: "Formulario" },
        { title: "Produtor", code: "Produtor" },
        { title: "Data Inicial", code: "DataInicial" },
        { title: "Data Final", code: "DataFinal" },
      ],
      fields:
        getDetails &&
        getDetails.map((item) => {
          return {
            ID: item.id,
            Projeto: item.project?.description,
            Tecnico: item.user?.name,
            Formulario: item.form?.title,
            DataInicial: moment(item.startDate).format("DD/MM/YYYY"),
            DataFinal: moment(item.endDate).format("DD/MM/YYYY"),
            Produtor: item.assistUser[0]?.userFarmer[0]?.name,
          }
        }),
      columns: ["ID", "Projeto", "Tecnico", "Formulario", "DataInicial", "DataFinal", "Produtor"],
    }
  }

  const userTec =
    temp &&
    temp?.map((item) => ({
      value: item.id,
      label: item.name,
    }))

  const unionDW = { ...dw, ...dataFilter, tecnico: userTec }

  return (
    <>
      <SubHeaderFilterTable
        {...{ setIsOpen, isOpen, dw: unionDW, onChange, values, control, onSearch }}
      />
      <AssistanceListScreen {...{ transformDataToTable: transform, onFilter }} />
    </>
  )
}

export default AssistanceListContainer
